<template>
  <AppHeader>Notifications</AppHeader>

  <Loading v-if="state == 'loading'"></Loading>

  <div v-if="state == 'idle'" class="p-4">
    <div class="flex flex-col bg-white rounded-2xl shadow-sm divide-y-2 divide-slate-100">

      <div @click="openNotification(noti)" v-for="noti in data.notifications" :key="noti.id" class="px-3 py-2 cursor-pointer">
        <p class="text-gray-500">{{ toDate(noti.created_at, true) }}</p>
        <p class="my-1 text-lg">{{ noti.title }}</p>
        <p class="text-sm leading-tight text-gray-500">{{ noti.description }}</p>
      </div>

    </div>

    <div class="mt-3 text-center">
      <button @click="getData()" class="px-4 py-2 leading-none rounded-full bg-slate-300">Load More</button>
    </div>
  </div>
</template>

<script>
import mixin from '@/utils/mixin.js';
import AppHeader from '@/components/common/Header.vue';
import Loading from '@/components/common/Loading.vue';

export default {
  name: 'Notifications',
  mixins: [ mixin ],
  components: { AppHeader, Loading },
  data() {
    return {
      state: 'loading',
      page: 1,
      data: { notifications: [] },
    }
  },

  methods: {
    getData() {
      this.request('GET', 'notifications?page=' + this.page, {}, (resp) => {
        this.state = 'idle';
        if (resp.success) {
          this.data.notifications = this.data.notifications.concat(resp.data.notifications.data);
          this.page += 1;
        }
      });
    },

    openNotification(noti) {
      if (noti.link) {
        if (noti.type == 'internal') this.$router.push(noti.link);
        if (noti.type == 'external') window.open(noti.link, '_system');
      }
    },
  },

  created() {
    if (!this.$store.state.api_token) this.$router.push('/');
    else this.getData();
  }
}
</script>
